export const MapViewerIframeWindow = () => _.get(document.getElementById('map_viewer_iframe'), 'contentWindow', null);
export const appVersion = '4.1.0';
